import { render, staticRenderFns } from "./userapi-webhook-handler.vue?vue&type=template&id=65a37d27&"
import script from "./userapi-webhook-handler.vue?vue&type=script&lang=js&"
export * from "./userapi-webhook-handler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports